import styled from '@emotion/styled';
import { COLORS } from 'styles';
import Button from '../Button';

export type { ButtonProps } from '@mui/material/Button';

const SecondaryButton = styled(Button)`
  padding: 12px 20px;
  line-height: 1.3;
  background: ${COLORS.BLUE500};
  color: ${COLORS.WHITE};

  &:hover {
    background: ${COLORS.SECONDARY_HOVER};
  }

  &:disabled {
    border-color: ${COLORS.INACTIVE_BUTTON};
    background: ${COLORS.INACTIVE_BUTTON};
  }

  &:disabled:hover {
    border-color: ${COLORS.INACTIVE_BUTTON_HOVER};
    background: ${COLORS.INACTIVE_BUTTON_HOVER};
  }
`;

export default SecondaryButton;
